module.exports = {"431128100":"龙泉镇","431128101":"金陵镇","431128102":"骥村镇","431128103":"枧头镇","431128104":"新圩镇","431128105":"石羊镇","431128106":"新隆镇","431128107":"三井镇","431128108":"大坪塘镇","431128109":"陶岭镇","431128110":"金盆镇","431128202":"门楼下瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431128.json
// module id = 1912
// module chunks = 0